import { Injectable } from '@angular/core';

/**
 * Calls the Android WebView {@code @JavascriptInterface} exposed as {@code window.TapToPayAndroid}.
 * Replaces legacy taptopay://payment deep links when the app hosts the Angular app in a WebView.
 *
 * **Capability contract:** UI that offers “Tap to Pay” must gate on {@link isAvailable} (presence of
 * {@code window.TapToPayAndroid.startPayment}). Do not use viewport or UA alone — those are true in
 * mobile browsers where Terminal is not available.
 */
declare global {
  interface Window {
    TapToPayAndroid?: {
      startPayment?: (jsonPayload: string) => void;
      getAppVersion?: () => string;
    };
  }
}

@Injectable({ providedIn: 'root' })
export class TapToPayAndroidNativeService {
  get isAvailable(): boolean {
    return typeof window !== 'undefined' && typeof window.TapToPayAndroid?.startPayment === 'function';
  }

  /** Sends the same key/value pairs as the former deep-link query string, as one JSON object. */
  startPaymentFromParams(params: URLSearchParams): void {
    const fields: Record<string, string> = {};
    params.forEach((value, key) => {
      if (value != null && value !== '') {
        fields[key] = value;
      }
    });
    this.startPaymentObject(fields);
  }

  startPaymentObject(fields: Record<string, string>): void {
    const bridge = window.TapToPayAndroid;
    if (!bridge?.startPayment) {
      console.warn('[TapToPay] TapToPayAndroid native bridge is not available (open inside Tap to Pay Android WebView).');
      return;
    }
    bridge.startPayment(JSON.stringify(fields));
  }
}
